import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Primitive, styled } from '@miro-site/ui-styled-engine';
import { Grid, GridItem, Section, Typography, Box, Container, Button, ArrowToRight, Image } from '@miro-site/ui-core';
import SlidingContent from './SlidingContent';
import JSONLD from './JsonLD';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HowToSlidingImageContent = styled(Primitive.div, {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  '@md': {
    backgroundColor: '$indigo-90',
    paddingY: '$800'
  },
  '.dotted-bg': {
    display: 'none',
    '@md': {
      height: '100%',
      display: 'flex'
    },
    background: 'white',
    backgroundImage: 'radial-gradient(#d2d2d2 1px, transparent 0)',
    backgroundSize: '30px 30px',
    backgroundColor: '#F0F0F3',
    aspectRatio: '16/9',
    borderRadius: '$200',
    marginBottom: '$300',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

var HowTo = function HowTo(props) {
  var _props$items2;

  var howToSlidingContentGenerator = function howToSlidingContentGenerator(index) {
    var currentItem = props.items ? props === null || props === void 0 ? void 0 : props.items[index] : null;

    if (!currentItem) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Box, {
        css: {
          width: '48px',
          height: '48px',
          backgroundColor: '$blue-10',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '$300',
          marginTop: index === 0 ? '$600' : '0'
        },
        children: /*#__PURE__*/_jsx(Typography, {
          tag: "h2",
          type: "heading",
          variant: "sub-heading-1",
          children: index + 1
        })
      }), /*#__PURE__*/_jsx(Typography, {
        color: "tertiary",
        variant: "heading-4",
        tag: "h3",
        type: "heading",
        offsetBottom: "stacking-300",
        renderChildrenAsHTML: true,
        children: (currentItem === null || currentItem === void 0 ? void 0 : currentItem.title) || ''
      }), /*#__PURE__*/_jsx(Typography, {
        color: "tertiary",
        variant: "body-text-1",
        renderChildrenAsHTML: true,
        children: (currentItem === null || currentItem === void 0 ? void 0 : currentItem.content) || ''
      })]
    });
  };

  var howToSlidingImageGenerator = function howToSlidingImageGenerator(index) {
    var _props$cta, _props$cta2;

    var currentItem = props.items ? props === null || props === void 0 ? void 0 : props.items[index] : null;

    if (!currentItem) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }

    return /*#__PURE__*/_jsxs(HowToSlidingImageContent, {
      children: [/*#__PURE__*/_jsx(Typography, {
        color: "tertiary",
        variant: "heading-2",
        tag: "h2",
        type: "heading",
        offsetBottom: {
          '@initial': 'stacking-200',
          '@md': 'stacking-300'
        },
        renderChildrenAsHTML: true,
        children: (props === null || props === void 0 ? void 0 : props.title) || ''
      }), /*#__PURE__*/_jsx(Typography, {
        color: "tertiary",
        variant: "body-text-1",
        offsetBottom: {
          '@initial': '400',
          '@lg': '600'
        },
        renderChildrenAsHTML: true,
        children: (props === null || props === void 0 ? void 0 : props.content) || ''
      }), /*#__PURE__*/_jsx("div", {
        className: "dotted-bg",
        children: /*#__PURE__*/_jsx(Image, {
          image: currentItem.image.desktop
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Button, {
          endIcon: /*#__PURE__*/_jsx(ArrowToRight, {}),
          rounded: true,
          size: "large",
          variant: "primary",
          css: {
            marginBottom: '$600',
            '@lg': {
              marginBottom: '$800'
            }
          },
          href: props === null || props === void 0 ? void 0 : (_props$cta = props.cta) === null || _props$cta === void 0 ? void 0 : _props$cta.href,
          children: props === null || props === void 0 ? void 0 : (_props$cta2 = props.cta) === null || _props$cta2 === void 0 ? void 0 : _props$cta2.text
        })
      })]
    });
  };

  var generateJSONLDProps = function generateJSONLDProps() {
    var _props$items;

    var finalJson = {
      step: []
    };
    props === null || props === void 0 ? void 0 : (_props$items = props.items) === null || _props$items === void 0 ? void 0 : _props$items.forEach(function (item) {
      finalJson.step.push({
        '@type': 'HowToStep',
        name: item.title,
        text: item.content,
        image: item.image.desktop.src
      });
    });
    return finalJson;
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(JSONLD, _objectSpread({
      type: "HowTo"
    }, generateJSONLDProps())), /*#__PURE__*/_jsx(Section, {
      css: {
        backgroundColor: '$indigo-90',
        '@lg': {
          backgroundColor: 'transparent'
        }
      },
      children: /*#__PURE__*/_jsx(Container, {
        disableGutter: true,
        children: /*#__PURE__*/_jsx(Box, {
          offsetTop: {
            '@initial': '600',
            '@md': '800',
            '@xl': '1200'
          },
          css: {
            backgroundColor: '$indigo-90',
            borderRadius: '$200',
            '@xxl': {
              marginX: '-56px',
              paddingX: '56px'
            }
          },
          children: /*#__PURE__*/_jsx(Grid, {
            disableGutter: true,
            children: /*#__PURE__*/_jsx(GridItem, {
              columnStart: {
                '@initial': 1
              },
              columnEnd: "-1",
              children: /*#__PURE__*/_jsx(SlidingContent, {
                slidingContentGenerator: howToSlidingContentGenerator,
                slidingImageGenerator: howToSlidingImageGenerator,
                itemCount: props === null || props === void 0 ? void 0 : (_props$items2 = props.items) === null || _props$items2 === void 0 ? void 0 : _props$items2.length,
                contentGridItemCss: {
                  opacity: 1
                },
                imageGridItemCss: {
                  justifyContent: 'center',
                  position: 'relative',
                  height: 'auto',
                  '@md': {
                    position: 'sticky'
                  }
                },
                contentColumnStartIndex: 8,
                contentColumnEndIndex: 12,
                imageColumnStartIndex: 1,
                imageColumnEndIndex: 7
              })
            })
          })
        })
      })
    })]
  });
};

export default HowTo;